import { AccessControlListDc, Permissions, RolePermissionDc } from "@evergis/api";

export const PUBLIC_ROLE = "__public";

export const PUBLIC_ROLE_PERMISSION: RolePermissionDc = {
  role: PUBLIC_ROLE,
  permissions: Permissions.Read,
};

export function isPublicAccess(acl?: AccessControlListDc): boolean {
  return acl && acl.data && acl.data.some(rolePermission => rolePermission.role === PUBLIC_ROLE);
}
